var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSeoul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 180,
    viewBox: "0 0 350 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 180,
    rx: 32,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_583_2579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.7 107.143C214.7 107.143 211.454 110.405 211.454 114.424C211.454 118.443 214.7 121.705 218.7 121.705C222.701 121.705 225.947 118.443 225.947 114.424C225.947 110.405 222.701 107.143 218.7 107.143ZM218.7 117.754C216.873 117.754 215.387 116.265 215.387 114.424C215.387 112.583 216.868 111.094 218.7 111.094C220.533 111.094 222.014 112.583 222.014 114.424C222.014 116.265 220.533 117.754 218.7 117.754Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.168 84.3647C140.168 84.3647 136.922 87.6269 136.922 91.6462C136.922 95.6655 140.163 98.9276 144.168 98.9276C148.174 98.9276 151.415 95.6707 151.415 91.6462C151.415 87.6217 148.174 84.3647 144.168 84.3647ZM144.168 94.9705C142.341 94.9705 140.855 93.4821 140.855 91.641C140.855 89.7999 142.336 88.3114 144.168 88.3114C146.001 88.3114 147.482 89.7999 147.482 91.641C147.482 93.4821 146.001 94.9705 144.168 94.9705Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.016 50.2036C219.108 62.5934 195.691 62.5727 173.93 58.6208C161.367 56.3388 146.058 51.0385 131.956 51.0852C126.119 51.106 120.487 52.0395 115.341 54.4822C98.004 62.7179 95.0155 79.5575 95 89.6965C95 92.2585 95.1858 94.39 95.3768 95.8473C95.5316 96.9261 95.6916 98.01 95.9291 99.1147C96.4297 101.423 97.5137 106.038 99.4647 101.734C99.8466 100.883 101.725 97.3099 102.949 95.2146C111.346 80.7762 128.426 75.7456 144.086 75.4189C159.932 75.0922 175.53 77.0577 191.376 75.5641C217.178 73.6711 231.914 60.6901 240.028 52.1017C243.796 47.9372 241.396 48.6944 239.011 50.2036H239.016Z",
    fill: "#0089CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.238 102.122H142.099V109.009H146.238V102.122Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.383 109.082H146.243V115.653H150.383V109.082Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.099 115.985H137.959V122.561H142.099V115.985Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.165 108.107L192.305 114.445L195.685 112.038L188.165 101.007L180.645 112.038L184.026 114.445L188.165 108.107Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.653 101.007H198.514V115.57H202.653V101.007Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.698 108.107L166.843 114.445L170.219 112.038L162.698 101.007L155.178 112.038L158.559 114.445L162.698 108.107Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.985 101.007H172.846V115.57H176.985V101.007Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.298 104.544H194.374V108.393H199.298V104.544Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.273 101.007H246.134V115.57H250.273V101.007Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 105.478H249.076V109.326H254V105.478Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.703 108.107L119.842 114.445L123.223 112.038L115.703 101.007L108.182 112.038L111.563 114.445L115.703 108.107Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.196 101.007H126.057V115.57H130.196V101.007Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.841 104.544H121.917V108.393H126.841V104.544Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.006 101.111H134.336V104.959H154.006V101.111Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.383 107.454H137.959V111.302H150.383V107.454Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.589 120.041H137.959V123.889H150.589V120.041Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.383 113.75H137.959V117.494H150.383V113.75Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.761 117.199H201.621V123.775H205.761V117.199Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.482 124.102H193.342V130.678H197.482V124.102Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.766 115.57H193.342V119.418H205.766V115.57Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.972 128.152H193.342V132H205.972V128.152Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.766 121.861H193.342V125.605H205.766V121.861Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.217 95.8057H215.077V102.693H219.217V95.8057Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.116 89.9038H220.977V97.8854H225.116V89.9038Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.533 101.111H208.868V104.959H228.533V101.111Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.121 87.0669H212.285V90.9151H225.121V87.0669Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.817 104.472H232.678V111.037H236.817V104.472Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.032 110.368H232.678V114.216H243.032V110.368Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.82 117.022H238.681V125.362H242.82V117.022Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.48 124.2H238.681V128.048H250.48V124.2Z",
    fill: "#69737A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.032 101.111H232.678V104.959H243.032V101.111Z",
    fill: "#69737A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_583_2579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 83,
    fill: "white",
    transform: "translate(95 49)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSeoul);
export default __webpack_public_path__ + "static/media/logo_seoul.f6e32cf04f004d2a9a6ed5383462e4f7.svg";
export { ForwardRef as ReactComponent };